export enum AnalyticsCustomEvents {
    ModelUploaded = 'model_uploaded',
    OrderStatusChange = 'order_status_change',
}
